import _regeneratorRuntime from "/app/node_modules/.pnpm/@babel+runtime-corejs2@7.24.1/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/app/node_modules/.pnpm/@babel+runtime-corejs2@7.24.1/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/.pnpm/@babel+runtime-corejs2@7.24.1/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import router from "./router";
import store from "./store";
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken } from '@/utils/auth'; // get token from cookie
import getPageTitle from '@/utils/get-page-title';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login']; // no redirect whitelist

router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(to, from, next) {
    var hasToken, hasRoles, _yield$store$dispatch, roles, accessRoutes;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // start progress bar
          NProgress.start();

          // set page title
          document.title = getPageTitle(to.meta.title);

          // determine whether the user has logged in
          hasToken = getToken();
          if (!hasToken) {
            _context.next = 36;
            break;
          }
          if (!(to.path === '/login')) {
            _context.next = 9;
            break;
          }
          // if is logged in, redirect to the home page
          next({
            path: '/'
          });
          NProgress.done();
          _context.next = 34;
          break;
        case 9:
          // determine whether the user has obtained his permission roles through getInfo
          hasRoles = store.getters.roles && store.getters.roles.length > 0;
          if (!hasRoles) {
            _context.next = 14;
            break;
          }
          next();
          _context.next = 34;
          break;
        case 14:
          _context.prev = 14;
          _context.next = 17;
          return store.dispatch('user/getInfo');
        case 17:
          _yield$store$dispatch = _context.sent;
          roles = _yield$store$dispatch.roles;
          _context.next = 21;
          return store.dispatch('permission/generateRoutes', roles);
        case 21:
          accessRoutes = _context.sent;
          console.log('access routes', accessRoutes);
          // dynamically add accessible routes
          router.addRoutes(accessRoutes);

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          if (to.path === '/' && roles.indexOf('admin') !== -1) {
            next(_objectSpread(_objectSpread({}, to), {}, {
              replace: true
            }));
          } else if (to.path === '/' && roles.indexOf('finance') !== -1) {
            next({
              name: 'adminDistributorSettle'
            });
          } else if (to.path === '/' && roles.indexOf('distributor') !== -1) {
            next({
              name: 'distributorHome'
            });
          } else if (to.path === '/' && roles.indexOf('operations_manager') !== -1) {
            next({
              name: 'adminDistributor'
            });
          } else {
            next(_objectSpread(_objectSpread({}, to), {}, {
              replace: true
            }));
          }
          _context.next = 34;
          break;
        case 27:
          _context.prev = 27;
          _context.t0 = _context["catch"](14);
          _context.next = 31;
          return store.dispatch('user/resetToken');
        case 31:
          Message.error(_context.t0 || 'Has Error');
          next("/login?redirect=".concat(to.path));
          NProgress.done();
        case 34:
          _context.next = 37;
          break;
        case 36:
          /* has no token*/

          if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next();
          } else {
            // other pages that do not have permission to access are redirected to the login page.
            next("/login?redirect=".concat(to.path));
            NProgress.done();
          }
        case 37:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[14, 27]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});